import { render, staticRenderFns } from "./minecraft.vue?vue&type=template&id=0bc0373d&scoped=true&"
import script from "./minecraft.vue?vue&type=script&lang=js&"
export * from "./minecraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc0373d",
  null
  
)

export default component.exports